import {Component} from '@angular/core';
import {Router} from '@angular/router';
import {GetParamsApiService} from './services/get-params-api.service';
import {SettingsService} from './services/settings.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'no30-dashboard';

  constructor(
    private router: Router,
    private getParamsService: GetParamsApiService,
    private settings: SettingsService,
  ) {
    const params = new URLSearchParams(window.location.search);

    if (params.get('logout') === 'true') {
      localStorage.removeItem('session');
      this.router.navigate(['/login'], { replaceUrl: true });
      return;
    }


    const dataStorage = localStorage.getItem('session');

    if (dataStorage) {
      this.router.navigate(['modulos']);
    } else {
      this.router.navigate(['login']);
    }
  }
}
